<template>
  <div>
    <component :is="currentScreen" />
  </div>
</template>

<script>
  /**
  *   "steps" is an array of translations. Every element of array is an array of steps in certain language
  */

  import {
    EVENT_SET_SCENARIO,
    EVENT_GA_SEND,
    PAGE_URL_ENGLISH,
    PAGE_URL_FRENCH,
    PAGE_URL_DEUTSCH,
    PAGE_URL_ITALIANO,
    PAGE_URL_RUSSIAN,
  } from '@/constants';

  import { mapState } from 'vuex';
  import { mapActions } from 'vuex';

  import mainScreenX from './screens/main-screen-x';

  export default {
    name: 'welcome-screens',
    components: {
      mainScreenX,
    },
    data() {
      return {
        product: null,
        creationLeadRequired: false,
        steps: [
          [
            {
              tooltip: {
                text: '<p>Let’s get going! Here we are at the main Netwrix Auditor screen. So, what do you want to start with</p>',
                showSteps: false,

                position: 'left',
                align: -0.1,
                alignArrow: 120,
                fixedArrow: true,
                actions: [
                  {
                    text: 'Data Discovery and Classification',
                    link: PAGE_URL_ENGLISH + '?scenario=data_discovery_and_classification',
                    id: 'sc1_st1',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 9,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'Data Discovery and Classification',
                          stage: 'Started',
                        },
                      },
                    ],
                  },
                  {
                    text: 'Risk Assessment',
                    link: PAGE_URL_ENGLISH + '?scenario=risk_assessment',
                    id: 'sc1_st1',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 8,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'Risk Assessment',
                          stage: 'Started',
                        },
                      },
                    ],
                  },
                  {
                    text: 'Enterprise Overview Dashboard',
                    link: PAGE_URL_ENGLISH + '?scenario=overview',
                    id: 'sc1_st1',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 1,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'Enterpise Overview',
                          stage: 'Started',
                        },
                      },
                    ],
                  },
                  {
                    text: 'Alerts',
                    link: PAGE_URL_ENGLISH + '?scenario=alerts',
                    id: 'sc7_st1',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 7,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'Alerts',
                          stage: 'Started',
                        },
                      },
                    ],
                  },
                  {
                    text: 'Behavior Anomaly Discovery',
                    link: PAGE_URL_ENGLISH + '?scenario=behavior_anomaly_discovery',
                    id: 'sc1_st1',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 10,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'Behavior Anomaly Discovery',
                          stage: 'Started',
                        },
                      },
                    ],
                  },
                  {
                    text: 'Interactive Search',
                    link: PAGE_URL_ENGLISH + '?scenario=search',
                    id: 'sc2_st1',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 2,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'Interactive Search',
                          stage: 'Started',
                        },
                      },
                    ],
                  },
                  {
                    text: 'Predefined Reports',
                    subactions: [
                      {
                        text: 'User Account Status Changes',
                        link: PAGE_URL_ENGLISH + '?scenario=user_account_changes',
                        id: 'sc3_st1',
                        events: [
                          {
                            type: EVENT_SET_SCENARIO,
                            value: 3,
                          },
                          {
                            type: EVENT_GA_SEND,
                            value: {
                              scenario: 'User Accounts Status Changes',
                              stage: 'Started',
                            },
                          },
                        ],
                      },
                      {
                        text: 'File and Folder Permission Details',
                        link: PAGE_URL_ENGLISH + '?scenario=folder_and_file_prm',
                        id: 'sc4_st1',
                        events: [
                          {
                            type: EVENT_SET_SCENARIO,
                            value: 4,
                          },
                          {
                            type: EVENT_GA_SEND,
                            value: {
                              scenario: 'File and Folders Permissions',
                              stage: 'Started',
                            },
                          },
                        ],
                      },
                      {
                        text: 'Windows Server Configuration Details',
                        link: PAGE_URL_ENGLISH + '?scenario=windows_server_configuration',
                        id: 'sc5_st1',
                        events: [
                          {
                            type: EVENT_SET_SCENARIO,
                            value: 5,
                          },
                          {
                            type: EVENT_GA_SEND,
                            value: {
                              scenario: 'Windows Server Configuration',
                              stage: 'Started',
                            },
                          },
                        ],
                      },
                      {
                        text: 'Activity Outside Business Hours',
                        link: PAGE_URL_ENGLISH + '?scenario=activity_outside_business_hours',
                        id: 'sc6_st1',
                        events: [
                          {
                            type: EVENT_SET_SCENARIO,
                            value: 6,
                          },
                          {
                            type: EVENT_GA_SEND,
                            value: {
                              scenario: 'Activity Outside Business Hours',
                              stage: 'Started',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    text: 'Compliance Reports',
                    link: PAGE_URL_ENGLISH + '?scenario=compliance_reports',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 11,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'Compliance Reports',
                          stage: 'Started',
                        },
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 108,
                y: 142,
                width: 1057,
                height: 586,
              },
              screen: 'main-screen-x',
            },
            {
              tooltip: {
                text: '<p>Let’s get going! Here we are at the main Netwrix Auditor screen. So, what do you want to start with</p>',
                showSteps: false,
                fading: false,
                position: 'left',
                align: -0.1,
                alignArrow: 120,
                fixedArrow: true,
                actions: [
                  {
                    text: 'Data Discovery and Classification',
                    link: PAGE_URL_ENGLISH + '?scenario=data_discovery_and_classification',
                    id: 'sc1_st1',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 9,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'Data Discovery and Classification',
                          stage: 'Started',
                        },
                      },
                    ],
                  },
                  {
                    text: 'Predefined Reports',
                    subactions: [
                      {
                        text: 'User Account Status Changes',
                        link: PAGE_URL_ENGLISH + '?scenario=user_account_changes',
                        id: 'sc3_st1',
                        events: [
                          {
                            type: EVENT_SET_SCENARIO,
                            value: 3,
                          },
                          {
                            type: EVENT_GA_SEND,
                            value: {
                              scenario: 'User Accounts Status Changes',
                              stage: 'Started',
                            },
                          },
                        ],
                      },
                      {
                        text: 'File and Folder Permission Details',
                        link: PAGE_URL_ENGLISH + '?scenario=folder_and_file_prm',
                        id: 'sc4_st1',
                        events: [
                          {
                            type: EVENT_SET_SCENARIO,
                            value: 4,
                          },
                          {
                            type: EVENT_GA_SEND,
                            value: {
                              scenario: 'File and Folders Permissions',
                              stage: 'Started',
                            },
                          },
                        ],
                      },
                      {
                        text: 'Windows Server Configuration Details',
                        link: PAGE_URL_ENGLISH + '?scenario=windows_server_configuration',
                        id: 'sc5_st1',
                        events: [
                          {
                            type: EVENT_SET_SCENARIO,
                            value: 5,
                          },
                          {
                            type: EVENT_GA_SEND,
                            value: {
                              scenario: 'Windows Server Configuration',
                              stage: 'Started',
                            },
                          },
                        ],
                      },
                      {
                        text: 'Activity Outside Business Hours',
                        link: PAGE_URL_ENGLISH + '?scenario=activity_outside_business_hours',
                        id: 'sc6_st1',
                        events: [
                          {
                            type: EVENT_SET_SCENARIO,
                            value: 6,
                          },
                          {
                            type: EVENT_GA_SEND,
                            value: {
                              scenario: 'Activity Outside Business Hours',
                              stage: 'Started',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    text: 'Compliance Reports',
                    link: PAGE_URL_ENGLISH + '?scenario=compliance_reports',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 11,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'Compliance Reports',
                          stage: 'Started',
                        },
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 108,
                y: 142,
                width: 1057,
                height: 586,
              },
              screen: 'main-screen-x',
            },
          ],
          [
            {
              tooltip: {
                text: '<p>Voici l’écran principal de Netwrix Auditor. Par quoi voulez-vous commencer ?</p>',
                showSteps: false,
                width: 458,
                position: 'left',
                align: -0.1,
                alignArrow: 120,
                fixedArrow: true,

                actions: [
                  {
                    text: 'Découverte et classification des données',
                    link: PAGE_URL_FRENCH + '?scenario=data_discovery_and_classification',
                    id: 'sc1_st1',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 9,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'Data Discovery and Classification',
                          stage: 'Started',
                        },
                      },
                    ],
                  },
                  {
                    text: 'Évaluation des risques',
                    link: PAGE_URL_FRENCH + '?scenario=risk_assessment',
                    id: 'sc1_st1',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 8,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'Risk Assessment',
                          stage: 'Started',
                        },
                      },
                    ],
                  },
                  {
                    text: 'Tableau de bord de vue d’ensemble de l’entreprise',
                    link: PAGE_URL_FRENCH + '?scenario=overview',
                    id: 'sc1_st1',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 1,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'Enterpise Overview',
                          stage: 'Started',
                        },
                      },
                    ],
                  },
                  {
                    text: 'Alertes',
                    link: PAGE_URL_FRENCH + '?scenario=alerts',
                    id: 'sc7_st1',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 7,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'Alerts',
                          stage: 'Started',
                        },
                      },
                    ],
                  },
                  {
                    text: 'Découverte des comportements anormaux',
                    link: PAGE_URL_FRENCH + '?scenario=behavior_anomaly_discovery',
                    id: 'sc1_st1',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 10,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'Behavior Anomaly Discovery',
                          stage: 'Started',
                        },
                      },
                    ],
                  },
                  {
                    text: 'Recherche interactive',
                    link: PAGE_URL_ENGLISH + '?scenario=search',
                    id: 'sc2_st1',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 2,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'Interactive Search',
                          stage: 'Started',
                        },
                      },
                    ],
                  },
                  {
                    text: 'Rapports prédéfinis',
                    subactions: [
                      {
                        text: 'Modifications de l’état des comptes d’utilisateur',
                        link: PAGE_URL_FRENCH + '?scenario=user_account_changes',
                        id: 'sc3_st1',
                        events: [
                          {
                            type: EVENT_SET_SCENARIO,
                            value: 3,
                          },
                          {
                            type: EVENT_GA_SEND,
                            value: {
                              scenario: 'User Accounts Status Changes',
                              stage: 'Started',
                            },
                          },
                        ],
                      },
                      {
                        text: 'Détails des autorisations pour les fichiers et dossiers',
                        link: PAGE_URL_FRENCH + '?scenario=folder_and_file_prm',
                        id: 'sc4_st1',
                        events: [
                          {
                            type: EVENT_SET_SCENARIO,
                            value: 4,
                          },
                          {
                            type: EVENT_GA_SEND,
                            value: {
                              scenario: 'File and Folders Permissions',
                              stage: 'Started',
                            },
                          },
                        ],
                      },
                      {
                        text: 'Détails des configurations pour Windows Server',
                        link: PAGE_URL_FRENCH + '?scenario=windows_server_configuration',
                        id: 'sc5_st1',
                        events: [
                          {
                            type: EVENT_SET_SCENARIO,
                            value: 5,
                          },
                          {
                            type: EVENT_GA_SEND,
                            value: {
                              scenario: 'Windows Server Configuration',
                              stage: 'Started',
                            },
                          },
                        ],
                      },
                      {
                        text: 'Activité hors des heures de travail',
                        link: PAGE_URL_FRENCH + '?scenario=activity_outside_business_hours',
                        id: 'sc6_st1',
                        events: [
                          {
                            type: EVENT_SET_SCENARIO,
                            value: 6,
                          },
                          {
                            type: EVENT_GA_SEND,
                            value: {
                              scenario: 'Activity Outside Business Hours',
                              stage: 'Started',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    text: 'Rapports de conformité',
                    link: PAGE_URL_FRENCH + '?scenario=compliance_reports',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 11,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'Compliance Reports',
                          stage: 'Started',
                        },
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 108,
                y: 142,
                width: 1057,
                height: 586,
              },
              screen: 'main-screen-x',
            },
            {
              tooltip: {
                text: '<p>Voici l’écran principal de Netwrix Auditor. Par quoi voulez-vous commencer ?</p>',
                showSteps: false,
                width: 458,
                position: 'left',
                align: -0.1,
                alignArrow: 120,
                fixedArrow: true,

                actions: [
                  {
                    text: 'Découverte et classification des données',
                    link: PAGE_URL_FRENCH + '?scenario=data_discovery_and_classification',
                    id: 'sc1_st1',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 9,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'Data Discovery and Classification',
                          stage: 'Started',
                        },
                      },
                    ],
                  },
                  {
                    text: 'Tableau de bord de vue d’ensemble de l’entreprise',
                    link: PAGE_URL_FRENCH + '?scenario=overview',
                    id: 'sc1_st1',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 1,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'Enterpise Overview',
                          stage: 'Started',
                        },
                      },
                    ],
                  },
                  {
                    text: 'Rapports prédéfinis',
                    subactions: [
                      {
                        text: 'Modifications de l’état des comptes d’utilisateur',
                        link: PAGE_URL_FRENCH + '?scenario=user_account_changes',
                        id: 'sc3_st1',
                        events: [
                          {
                            type: EVENT_SET_SCENARIO,
                            value: 3,
                          },
                          {
                            type: EVENT_GA_SEND,
                            value: {
                              scenario: 'User Accounts Status Changes',
                              stage: 'Started',
                            },
                          },
                        ],
                      },
                      {
                        text: 'Détails des autorisations pour les fichiers et dossiers',
                        link: PAGE_URL_FRENCH + '?scenario=folder_and_file_prm',
                        id: 'sc4_st1',
                        events: [
                          {
                            type: EVENT_SET_SCENARIO,
                            value: 4,
                          },
                          {
                            type: EVENT_GA_SEND,
                            value: {
                              scenario: 'File and Folders Permissions',
                              stage: 'Started',
                            },
                          },
                        ],
                      },
                      {
                        text: 'Détails des configurations pour Windows Server',
                        link: PAGE_URL_FRENCH + '?scenario=windows_server_configuration',
                        id: 'sc5_st1',
                        events: [
                          {
                            type: EVENT_SET_SCENARIO,
                            value: 5,
                          },
                          {
                            type: EVENT_GA_SEND,
                            value: {
                              scenario: 'Windows Server Configuration',
                              stage: 'Started',
                            },
                          },
                        ],
                      },
                      {
                        text: 'Activité hors des heures de travail',
                        link: PAGE_URL_FRENCH + '?scenario=activity_outside_business_hours',
                        id: 'sc6_st1',
                        events: [
                          {
                            type: EVENT_SET_SCENARIO,
                            value: 6,
                          },
                          {
                            type: EVENT_GA_SEND,
                            value: {
                              scenario: 'Activity Outside Business Hours',
                              stage: 'Started',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    text: 'Rapports de conformité',
                    link: PAGE_URL_FRENCH + '?scenario=compliance_reports',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 11,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'Compliance Reports',
                          stage: 'Started',
                        },
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 108,
                y: 142,
                width: 1057,
                height: 586,
              },
              screen: 'main-screen-x',
            },
          ],
          [
            {
              tooltip: {
                text: '<p>Los geht‘s! Sie sehen hier den Hauptbildschirm von Netwrix Auditor. Womit möchten Sie beginnen?</p>',
                showSteps: false,
                width: 458,
                position: 'left',
                align: -0.1,
                alignArrow: 120,
                fixedArrow: true,

                actions: [
                  {
                    text: 'Daten auffinden und klassifizieren',
                    link: PAGE_URL_DEUTSCH + '?scenario=data_discovery_and_classification',
                    id: 'sc1_st1',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 9,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'Data Discovery and Classification',
                          stage: 'Started',
                        },
                      },
                    ],
                  },
                  {
                    text: 'Risikobewertung',
                    link: PAGE_URL_DEUTSCH + '?scenario=risk_assessment',
                    id: 'sc1_st1',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 8,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'Risk Assessment',
                          stage: 'Started',
                        },
                      },
                    ],
                  },
                  {
                    text: 'Dashboard "Enterprise Overview"',
                    link: PAGE_URL_DEUTSCH + '?scenario=overview',
                    id: 'sc1_st1',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 1,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'Enterpise Overview',
                          stage: 'Started',
                        },
                      },
                    ],
                  },
                  {
                    text: 'Warnmeldungen',
                    link: PAGE_URL_DEUTSCH + '?scenario=alerts',
                    id: 'sc7_st1',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 7,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'Alerts',
                          stage: 'Started',
                        },
                      },
                    ],
                  },
                  {
                    text: 'Abnormales Verhalten von AD-Accounts erkennen',
                    link: PAGE_URL_DEUTSCH + '?scenario=behavior_anomaly_discovery',
                    id: 'sc1_st1',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 10,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'Behavior Anomaly Discovery',
                          stage: 'Started',
                        },
                      },
                    ],
                  },
                  {
                    text: 'Interaktive Google-ähnliche Suche',
                    link: PAGE_URL_DEUTSCH + '?scenario=search',
                    id: 'sc2_st1',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 2,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'Interactive Search',
                          stage: 'Started',
                        },
                      },
                    ],
                  },
                  {
                    text: 'Vordefinierte Berichte',
                    subactions: [
                      {
                        text: 'Änderungen am Status von Benutzerkonten',
                        link: PAGE_URL_DEUTSCH + '?scenario=user_account_changes',
                        id: 'sc3_st1',
                        events: [
                          {
                            type: EVENT_SET_SCENARIO,
                            value: 3,
                          },
                          {
                            type: EVENT_GA_SEND,
                            value: {
                              scenario: 'User Accounts Status Changes',
                              stage: 'Started',
                            },
                          },
                        ],
                      },
                      {
                        text: 'Datei- und Ordnerberechtigungen',
                        link: PAGE_URL_DEUTSCH + '?scenario=folder_and_file_prm',
                        id: 'sc4_st1',
                        events: [
                          {
                            type: EVENT_SET_SCENARIO,
                            value: 4,
                          },
                          {
                            type: EVENT_GA_SEND,
                            value: {
                              scenario: 'File and Folders Permissions',
                              stage: 'Started',
                            },
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 108,
                y: 142,
                width: 1057,
                height: 586,
              },
              screen: 'main-screen-x',
            },
            {
              tooltip: {
                text: '<p>Los geht‘s! Sie sehen hier den Hauptbildschirm von Netwrix Auditor. Womit möchten Sie beginnen?</p>',
                showSteps: false,
                width: 458,
                position: 'left',
                align: -0.1,
                alignArrow: 120,
                fixedArrow: true,

                actions: [
                  {
                    text: 'Daten auffinden und klassifizieren',
                    link: PAGE_URL_DEUTSCH + '?scenario=data_discovery_and_classification',
                    id: 'sc1_st1',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 9,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'Data Discovery and Classification',
                          stage: 'Started',
                        },
                      },
                    ],
                  },
                  {
                    text: 'Vordefinierte Berichte',
                    subactions: [
                      {
                        text: 'Änderungen am Status von Benutzerkonten',
                        link: PAGE_URL_DEUTSCH + '?scenario=user_account_changes',
                        id: 'sc3_st1',
                        events: [
                          {
                            type: EVENT_SET_SCENARIO,
                            value: 3,
                          },
                          {
                            type: EVENT_GA_SEND,
                            value: {
                              scenario: 'User Accounts Status Changes',
                              stage: 'Started',
                            },
                          },
                        ],
                      },
                      {
                        text: 'Datei- und Ordnerberechtigungen',
                        link: PAGE_URL_DEUTSCH + '?scenario=folder_and_file_prm',
                        id: 'sc4_st1',
                        events: [
                          {
                            type: EVENT_SET_SCENARIO,
                            value: 4,
                          },
                          {
                            type: EVENT_GA_SEND,
                            value: {
                              scenario: 'File and Folders Permissions',
                              stage: 'Started',
                            },
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 108,
                y: 142,
                width: 1057,
                height: 586,
              },
              screen: 'main-screen-x',
            },
          ],
          [
            {
              tooltip: {
                text: '<p>Cominciamo! Eccoci nella schermata principale di Netwrix Auditor. Allora, da cosa vuoi iniziare?</p>',
                showSteps: false,
                width: 458,
                position: 'left',
                align: -0.1,
                alignArrow: 120,
                fixedArrow: true,

                actions: [
                  {
                    text: 'Data Discovery and Classification',
                    link: PAGE_URL_ITALIANO + '?scenario=data_discovery_and_classification',
                    id: 'sc1_st1',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 9,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'Data Discovery and Classification',
                          stage: 'Started',
                        },
                      },
                    ],
                  },
                  {
                    text: 'Risk Assessment',
                    link: PAGE_URL_ITALIANO + '?scenario=risk_assessment',
                    id: 'sc1_st1',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 8,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'Risk Assessment',
                          stage: 'Started',
                        },
                      },
                    ],
                  },
                  {
                    text: 'Dashboard panoramica aziendale',
                    link: PAGE_URL_ITALIANO + '?scenario=overview',
                    id: 'sc1_st1',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 1,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'Enterpise Overview',
                          stage: 'Started',
                        },
                      },
                    ],
                  },
                  {
                    text: 'Scoperta del comportamento anomalo',
                    link: PAGE_URL_ITALIANO + '?scenario=behavior_anomaly_discovery',
                    id: 'sc1_st1',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 10,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'Behavior Anomaly Discovery',
                          stage: 'Started',
                        },
                      },
                    ],
                  },
                  {
                    text: 'Avvisi',
                    link: PAGE_URL_ITALIANO + '?scenario=alerts',
                    id: 'sc7_st1',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 7,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'Alerts',
                          stage: 'Started',
                        },
                      },
                    ],
                  },
                  {
                    text: 'Report predefiniti',
                    subactions: [
                      {
                        text: 'Modifiche allo status dell’account utente ',
                        link: PAGE_URL_ITALIANO + '?scenario=user_account_changes',
                        id: 'sc3_st1',
                        events: [
                          {
                            type: EVENT_SET_SCENARIO,
                            value: 3,
                          },
                          {
                            type: EVENT_GA_SEND,
                            value: {
                              scenario: 'User Accounts Status Changes',
                              stage: 'Started',
                            },
                          },
                        ],
                      },
                      {
                        text: 'Dettagli di autorizzazione a file e cartelle ',
                        link: PAGE_URL_ITALIANO + '?scenario=folder_and_file_prm',
                        id: 'sc4_st1',
                        events: [
                          {
                            type: EVENT_SET_SCENARIO,
                            value: 4,
                          },
                          {
                            type: EVENT_GA_SEND,
                            value: {
                              scenario: 'File and Folders Permissions',
                              stage: 'Started',
                            },
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 108,
                y: 142,
                width: 1057,
                height: 586,
              },
              screen: 'main-screen-x',
            },
            {
              tooltip: {
                text: '<p>Cominciamo! Eccoci nella schermata principale di Netwrix Auditor. Allora, da cosa vuoi iniziare?</p>',
                showSteps: false,
                width: 458,
                position: 'left',
                align: -0.1,
                alignArrow: 120,
                fixedArrow: true,

                actions: [
                  {
                    text: 'Data Discovery and Classification',
                    link: PAGE_URL_ITALIANO + '?scenario=data_discovery_and_classification',
                    id: 'sc1_st1',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 9,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'Data Discovery and Classification',
                          stage: 'Started',
                        },
                      },
                    ],
                  },
                  {
                    text: 'Report predefiniti',
                    subactions: [
                      {
                        text: 'Modifiche allo status dell’account utente ',
                        link: PAGE_URL_ITALIANO + '?scenario=user_account_changes',
                        id: 'sc3_st1',
                        events: [
                          {
                            type: EVENT_SET_SCENARIO,
                            value: 3,
                          },
                          {
                            type: EVENT_GA_SEND,
                            value: {
                              scenario: 'User Accounts Status Changes',
                              stage: 'Started',
                            },
                          },
                        ],
                      },
                      {
                        text: 'Dettagli di autorizzazione a file e cartelle ',
                        link: PAGE_URL_ITALIANO + '?scenario=folder_and_file_prm',
                        id: 'sc4_st1',
                        events: [
                          {
                            type: EVENT_SET_SCENARIO,
                            value: 4,
                          },
                          {
                            type: EVENT_GA_SEND,
                            value: {
                              scenario: 'File and Folders Permissions',
                              stage: 'Started',
                            },
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 108,
                y: 142,
                width: 1057,
                height: 586,
              },
              screen: 'main-screen-x',
            },
          ],
          [
            {
              tooltip: {
                text: '<p>Поехали! Перед нами главное окно Netwrix Auditor.<br> С чего начнем?</p>',
                showSteps: false,
                width: 488,
                position: 'left',
                align: -0.1,
                alignArrow: 120,
                fixedArrow: true,
                actions: [
                  {
                    text: 'Поиск и классификация данных',
                    link: PAGE_URL_RUSSIAN + '?scenario=data_discovery_and_classification',
                    id: 'sc1_st1',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 9,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'Data Discovery and Classification',
                          stage: 'Started',
                        },
                      },
                    ],
                  },
                  {
                    text: 'Оценка рисков',
                    link: PAGE_URL_RUSSIAN + '?scenario=risk_assessment',
                    id: 'sc1_st1',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 8,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'Risk Assessment',
                          stage: 'Started',
                        },
                      },
                    ],
                  },
                  {
                    text: 'Панель мониторинга инфраструктуры компании',
                    link: PAGE_URL_RUSSIAN + '?scenario=overview',
                    id: 'sc1_st1',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 1,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'Enterpise Overview',
                          stage: 'Started',
                        },
                      },
                    ],
                  },
                  {
                    text: 'Оповещения',
                    link: PAGE_URL_RUSSIAN + '?scenario=alerts',
                    id: 'sc7_st1',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 7,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'Alerts',
                          stage: 'Started',
                        },
                      },
                    ],
                  },
                  {
                    text: 'Аномальное поведение пользователей',
                    link: PAGE_URL_RUSSIAN + '?scenario=behavior_anomaly_discovery',
                    id: 'sc1_st1',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 10,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'Behavior Anomaly Discovery',
                          stage: 'Started',
                        },
                      },
                    ],
                  },
                  {
                    text: 'Интерактивный поиск',
                    link: PAGE_URL_RUSSIAN + '?scenario=search',
                    id: 'sc2_st1',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 2,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'Interactive Search',
                          stage: 'Started',
                        },
                      },
                    ],
                  },
                  {
                    text: 'Преднастроенные отчеты',
                    subactions: [
                      {
                        text: 'Изменения состояния учетных записей пользователей',
                        link: PAGE_URL_RUSSIAN + '?scenario=user_account_changes',
                        id: 'sc3_st1',
                        events: [
                          {
                            type: EVENT_SET_SCENARIO,
                            value: 3,
                          },
                          {
                            type: EVENT_GA_SEND,
                            value: {
                              scenario: 'User Accounts Status Changes',
                              stage: 'Started',
                            },
                          },
                        ],
                      },
                      {
                        text: 'Сведения о правах доступа к файлам и папкам',
                        link: PAGE_URL_RUSSIAN + '?scenario=folder_and_file_prm',
                        id: 'sc4_st1',
                        events: [
                          {
                            type: EVENT_SET_SCENARIO,
                            value: 4,
                          },
                          {
                            type: EVENT_GA_SEND,
                            value: {
                              scenario: 'File and Folders Permissions',
                              stage: 'Started',
                            },
                          },
                        ],
                      },
                      {
                        text: 'Конфигурации Windows Server',
                        link: PAGE_URL_RUSSIAN + '?scenario=windows_server_configuration',
                        id: 'sc5_st1',
                        events: [
                          {
                            type: EVENT_SET_SCENARIO,
                            value: 5,
                          },
                          {
                            type: EVENT_GA_SEND,
                            value: {
                              scenario: 'Windows Server Configuration',
                              stage: 'Started',
                            },
                          },
                        ],
                      },
                      {
                        text: 'Активность в нерабочее время',
                        link: PAGE_URL_ENGLISH + '?scenario=activity_outside_business_hours',
                        id: 'sc6_st1',
                        events: [
                          {
                            type: EVENT_SET_SCENARIO,
                            value: 6,
                          },
                          {
                            type: EVENT_GA_SEND,
                            value: {
                              scenario: 'Activity Outside Business Hours',
                              stage: 'Started',
                            },
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 108,
                y: 142,
                width: 1057,
                height: 586,
              },
              screen: 'main-screen-x',
            },
            {
              tooltip: {
                text: '<p>Поехали! Перед нами главное окно Netwrix Auditor.<br> С чего начнем?</p>',
                showSteps: false,
                width: 488,
                position: 'left',
                align: -0.1,
                alignArrow: 120,
                fixedArrow: true,
                actions: [
                  {
                    text: 'Поиск и классификация данных',
                    link: PAGE_URL_RUSSIAN + '?scenario=data_discovery_and_classification',
                    id: 'sc1_st1',
                    events: [
                      {
                        type: EVENT_SET_SCENARIO,
                        value: 9,
                      },
                      {
                        type: EVENT_GA_SEND,
                        value: {
                          scenario: 'Data Discovery and Classification',
                          stage: 'Started',
                        },
                      },
                    ],
                  },
                  {
                    text: 'Преднастроенные отчеты',
                    subactions: [
                      {
                        text: 'Изменения состояния учетных записей пользователей',
                        link: PAGE_URL_RUSSIAN + '?scenario=user_account_changes',
                        id: 'sc3_st1',
                        events: [
                          {
                            type: EVENT_SET_SCENARIO,
                            value: 3,
                          },
                          {
                            type: EVENT_GA_SEND,
                            value: {
                              scenario: 'User Accounts Status Changes',
                              stage: 'Started',
                            },
                          },
                        ],
                      },
                      {
                        text: 'Сведения о правах доступа к файлам и папкам',
                        link: PAGE_URL_RUSSIAN + '?scenario=folder_and_file_prm',
                        id: 'sc4_st1',
                        events: [
                          {
                            type: EVENT_SET_SCENARIO,
                            value: 4,
                          },
                          {
                            type: EVENT_GA_SEND,
                            value: {
                              scenario: 'File and Folders Permissions',
                              stage: 'Started',
                            },
                          },
                        ],
                      },
                      {
                        text: 'Конфигурации Windows Server',
                        link: PAGE_URL_RUSSIAN + '?scenario=windows_server_configuration',
                        id: 'sc5_st1',
                        events: [
                          {
                            type: EVENT_SET_SCENARIO,
                            value: 5,
                          },
                          {
                            type: EVENT_GA_SEND,
                            value: {
                              scenario: 'Windows Server Configuration',
                              stage: 'Started',
                            },
                          },
                        ],
                      },
                      {
                        text: 'Активность в нерабочее время',
                        link: PAGE_URL_ENGLISH + '?scenario=activity_outside_business_hours',
                        id: 'sc6_st1',
                        events: [
                          {
                            type: EVENT_SET_SCENARIO,
                            value: 6,
                          },
                          {
                            type: EVENT_GA_SEND,
                            value: {
                              scenario: 'Activity Outside Business Hours',
                              stage: 'Started',
                            },
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              viewArea: {
                x: 108,
                y: 142,
                width: 1057,
                height: 586,
              },
              screen: 'main-screen-x',
            },
          ],
        ],
      };
    },
    computed: {
      ...mapState('guide', ['currentScreen']),
      language() {
        return this.$store.state.guide.lang;
      },
    },
    methods: {
      ...mapActions('guide', ['setSteps']),
    },
    created() {
      this.setSteps(this.steps[this.language]);
    },
  };
</script>

<style scoped>

</style>
